import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgClass, NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'peps-logo',
	imports: [
		NgOptimizedImage,
		NgClass
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './team-peps-logo.component.html',
})
export class TeamPepsLogoComponent {

	@Input() width: number = 41;
	@Input() height: number = 48;
	@Input() hover: boolean = true;
	@Input() onClick: any = () => {};
}
